import { Component, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Applicant } from 'src/app/models/applicant.model';
import { ApplicantService } from 'src/app/services/applicant/applicant.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Md5 } from 'ts-md5';


@Component({
  selector: 'gabarito-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  faSpinner = faSpinner;
  activeSessionTab = 1;

  IsOAB = true;


  // Register
  registerForm: FormGroup;
  name: FormControl;
  email: FormControl;
  phone: FormControl;
  password: FormControl;
  confirmPassword: FormControl;
  hasNewsletter: FormControl;
  hasTerms: FormControl;
  showRegisterError = false;
  registerResultError = '';
  registerLoading = false;
  confirmPasswordNotSameError = false;
  confirmPasswordRequiredError = false;

  // Login
  loginForm: FormGroup;
  loginEmail: FormControl;
  loginPassword: FormControl;
  showLoginError = false;
  loginResultError = '';
  loginLoading = false;
   



  // Recover Password
  recoverPasswordForm: FormGroup;
  recoverPasswordEmail: FormControl;
  recoverPasswordLoading = false;
  recoverPasswordSended = false;
  showRecoverPasswordError = false;
  recoverPasswordResultError = '';
  config = {
    ignoreBackdropClick: true,
    keyboard: false
  };

  modalRef: BsModalRef;

  // Employee
  isEmployee = false;

  constructor(private authService: AuthService, private router: Router, private modalService: BsModalService,
              private applicantService: ApplicantService, private toastr: ToastrService) {

    this.createLoginForm({email: undefined, password: undefined});

    this.authService.loginSuccess.subscribe(
      () => {
        this.loginEmail = undefined;
        this.loginPassword = undefined;
        this.loginLoading = false;
        if (this.isEmployee) {
          if (this.authService.isEmployeeAdmin()) {
            this.router.navigate(['/employee/dashboard']);
          } else {
            this.router.navigate(['/employee/correct']);
          }
        } else {
          this.router.navigate(['/applicant/template/view']);
        }
      }
    );

    this.authService.loginFail.subscribe(
      (error: any) => {
        if (error.status === 401) {
          this.loginResultError = 'E-mail ou senha estão incorretos';
        } else {
          this.loginResultError = 'Erro inesperado, tente mais tarde';
          console.log(error);
        }
        this.loginLoading = false;
      }
    );

    if (this.router.url === '/login') {
      this.initApplicant();
    } else {
      this.initEmployee();
    }
  }

  initApplicant() {
    this.createRecoverPasswordForm();
    this.createRegisterForm(new Applicant());

    if (this.authService.isApplicantLoggedIn()) {
      this.router.navigate(['/applicant/template/view']);
    }
  }

  initEmployee() {
    this.isEmployee = true;

    if (this.authService.isEmployeeLoggedIn()) {
      this.router.navigate(['/employee/correct']);
    }
  }

  createRecoverPasswordForm() {
    this.recoverPasswordEmail = new FormControl(undefined, [Validators.required, , Validators.email]);

    this.recoverPasswordForm = new FormGroup({
      email: this.recoverPasswordEmail,
    });
  }

  createLoginForm(data) {
    this.loginEmail = new FormControl(data.email, Validators.required);
    this.loginPassword = new FormControl(data.password, Validators.required);

    this.loginForm = new FormGroup({
      email: this.loginEmail,
      password: this.loginPassword,
    });
  }

  createRegisterForm(applicant: Applicant) {
    this.name = new FormControl(applicant.name, [Validators.required, Validators.minLength(4)]);
    this.email = new FormControl(applicant.email, [Validators.required, Validators.email]);
    this.phone = new FormControl(applicant.phone, [Validators.minLength(10), Validators.maxLength(15),
        Validators.pattern('[1-9][1-9][1-9][0-9]{8}')]);
    this.password = new FormControl(applicant.password, [Validators.required, Validators.minLength(6), Validators.maxLength(15)]);
    this.confirmPassword = new FormControl(null);
    this.hasNewsletter = new FormControl(applicant.hasNewsletter);
    this.hasTerms = new FormControl(applicant.hasTerms, Validators.requiredTrue);

    this.registerForm = new FormGroup({
      name: this.name,
      email: this.email,
      phone: this.phone,
      password: this.password,
      confirmPassword: this.confirmPassword,
      hasNewsletter: this.hasNewsletter,
      hasTerms: this.hasTerms,
    });
  }

  confirmPasswordValidation() {
    if (this.confirmPassword.value === undefined || this.confirmPassword.value === null || this.confirmPassword.value === '') {
      this.confirmPasswordRequiredError = true;
      this.confirmPasswordNotSameError = false;
    } else {
      this.confirmPasswordRequiredError = false;

      if (this.confirmPassword.value === this.password.value) {
        this.confirmPasswordNotSameError = false;
      } else {
        this.confirmPasswordNotSameError = true;
      }
    }
  }

  openModal(template: TemplateRef<any>) {
    this.recoverPasswordSended = false;
    this.showRecoverPasswordError = false;
    this.recoverPasswordLoading = false;
    this.recoverPasswordResultError = '';
    this.recoverPasswordForm.reset();
    this.modalRef = this.modalService.show(template, this.config);
  }

  onSubimitLogin() {
    this.loginResultError = '';
    this.showLoginError = false;

    if (this.loginForm.valid) {
      this.loginLoading = true;
      this.signin();
    } else {
      this.showLoginError = true;
    }
  }

  signin() {

    const md5 = new Md5();
    const user = {
      email: this.loginForm.value.email,
      password: md5.appendStr(this.loginForm.value.password).end() as string
    };
    if (this.isEmployee) {
      this.authService.employeeSignin(user);
    } else {
      this.authService.applicantSignin(user);
    }
  }

  onRegisterSubmit(form) {
    this.showRegisterError = false;
    this.confirmPasswordValidation();
    this.registerResultError = '';
    if (this.registerForm.valid && !this.confirmPasswordNotSameError && !this.confirmPasswordRequiredError) {
      this.registerLoading = true;
      this.showRegisterError = false;
      this.createApplicant(form);
    } else {
      this.showRegisterError = true;
    }
  }

  createApplicant(form) {
    const newApplicant = new Applicant(this.registerForm.value);
    newApplicant.name = newApplicant.name.trim();
    const md5 = new Md5();
    newApplicant.password = md5.appendStr(this.registerForm.value.password).end() as string;
    this.applicantService.create(newApplicant).subscribe(
      response => {
        this.registerForm.reset();
        form.resetForm();
        this.toastr.success('Cadastro realizado com sucesso!', 'Bem Vindo', {
          positionClass: 'toast-bottom-right'
        });
        this.authService.applicantSignin(response);
        this.registerLoading = false;
      },
      error => {
        if (error.status === 400 && error.error.errors) {
          this.registerResultError = error.error.errors.reduce((a, b) => a.defaultMessage.concat(b.defaultMessage));
        }
        console.log('error', error);
        this.registerLoading = false;
      },
    );
  }

  onSubimitRecoverPassword() {
    this.recoverPasswordResultError = '';
    this.showRecoverPasswordError = false;
    if (this.recoverPasswordForm.valid) {
      this.recoverPasswordLoading = true;
      this.applicantService.requestChangePassword(this.recoverPasswordForm.value.email).subscribe(
        () => {
          this.recoverPasswordSended = true;
          this.recoverPasswordLoading = false;
        },
        error => {
          if (error.status === 404) {
            this.recoverPasswordResultError = 'E-mail não encontrado';
          } else {
            this.recoverPasswordResultError = 'Erro inesperado, tente mais tarde';
            console.log(error);
          }
          this.recoverPasswordLoading = false;
        }
      );
    } else {
      this.showRecoverPasswordError = true;
    }
  }

}
